import { jsxs as f, Fragment as D, jsx as i } from "react/jsx-runtime";
import { createPortal as F } from "react-dom";
import { forwardRef as H, useRef as w, useState as K, useImperativeHandle as S, useEffect as Z } from "react";
import { useId as q, useTracking as z, anchorPosition as G, onRoleButtonKeyDown as J, getText as Q } from "../utils.js";
import U from "../builders-icons/dist/systems/close.js";
import r from "./tooltip.module.css.js";
import y from "clsx";
const P = H(function({
  as: E,
  className: L,
  color: x = "blue",
  content: c,
  hover: C = !0,
  onOpen: u,
  size: N = "md",
  tooltipProps: n,
  tracking: R = !0,
  ...T
}, I) {
  var v;
  const M = E || "span", h = q(), l = w(null), s = w(null), [e, o] = K(!1), k = z(R);
  S(I, () => s.current), Z(() => {
    if (!e || !l.current || !s.current) return;
    const t = l.current, a = s.current, j = G(a, t, "center"), d = (g) => {
      const b = g.target, A = !a.contains(b) && !t.contains(b), B = g.key === "Escape";
      (A || B) && o(!1);
    };
    return document.addEventListener("click", d), document.addEventListener("keydown", d), () => {
      document.removeEventListener("click", d), document.removeEventListener("keypress", d), j();
    };
  }, [e, k]);
  const m = (t, a) => {
    o(t), k({
      eventCategory: "tooltip",
      eventAction: "open",
      eventLabel: Q(s.current)
    }), u == null || u(a);
  };
  return /* @__PURE__ */ f(D, { children: [
    /* @__PURE__ */ i(
      M,
      {
        "aria-describedby": (n == null ? void 0 : n.id) || h,
        className: y(r.button, L),
        onClick: (t) => c && (e === "click" ? o(!1) : m("click", t)),
        onFocus: (t) => c && !e && m("focus", t),
        onBlur: () => e === "focus" && o(!1),
        onMouseEnter: (t) => c && C && !e && m("hover", t),
        onMouseLeave: () => e === "hover" && o(!1),
        onKeyDown: J,
        tabIndex: c ? 0 : -1,
        role: c ? "button" : void 0,
        ref: s,
        ...T
      }
    ),
    e && c && F(
      /* @__PURE__ */ f(
        "div",
        {
          className: y(
            n == null ? void 0 : n.className,
            r.tooltip,
            r[x],
            r[N],
            e === "click" && r.clicked
          ),
          hidden: !e,
          id: (n == null ? void 0 : n.id) || h,
          ref: l,
          role: "tooltip",
          ...n,
          children: [
            /* @__PURE__ */ f(
              "svg",
              {
                xmlns: "http://www.w3.org/2000/svg",
                width: "21",
                height: "14",
                fill: "none",
                className: r.arrow,
                children: [
                  /* @__PURE__ */ i(
                    "path",
                    {
                      stroke: "none",
                      d: "M10 1c3.18 3.99 6.83 8.51 10 12.5H0C3.16 9.51 6.84 4.99 10 1Z"
                    }
                  ),
                  /* @__PURE__ */ i(
                    "path",
                    {
                      strokeLinecap: "round",
                      strokeLinejoin: "round",
                      d: "M19.53 12.5 10.01 1A4971.7 4971.7 0 0 0 .5 12.5"
                    }
                  )
                ]
              }
            ),
            c,
            /* @__PURE__ */ i(
              "button",
              {
                "aria-hidden": "true",
                className: r.close,
                hidden: e !== "click",
                onClick: () => o(!1),
                type: "button",
                children: /* @__PURE__ */ i(U, { width: 16, height: 16 })
              }
            )
          ]
        }
      ),
      // <dialog> will always win highetst z-index, so to ensure tooltip is on top place in parent dialog when applicable
      ((v = s.current) == null ? void 0 : v.closest("dialog")) || document.body
    )
  ] });
});
export {
  P as Tooltip
};
//# sourceMappingURL=tooltip.js.map
